module.exports = __webpack_public_path__ + "img/bookaweb-logo.8a468ee1.svg";